import { Fragment, useEffect } from 'react'
import { AuthProviderProps } from './props'
import { onAuthStateChanged } from 'firebase/auth'
import authStore from '../../../store/authStore'
import { auth } from '../../../firebase/firebase'
import { CircularProgress, Stack } from '@mui/material'

export default function AuthProvider(props: AuthProviderProps) {
  const isLoading = authStore(state => state.isLoading)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, firebaseUser => {
      authStore.setState({ user: firebaseUser, isLoading: false })
    })

    return () => unsubscribe()
  }, [])

  if (isLoading)
    return (
      <Stack alignItems={'center'} justifyContent={'center'} sx={{ width: '100vw', height: '100vh' }}>
        <CircularProgress size={60} />
      </Stack>
    )
  else return <Fragment>{props.children}</Fragment>
}
